import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawExternalLinkIcon from "./RawExternalLinkIcon.svg.jsx";

const ExternalLinkIcon = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawExternalLinkIcon}
      title="External Link"
      {...props}
    />
  );
});

export default ExternalLinkIcon;
